import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { I18nService } from '@digilize/shared/feature/modules/i18n/src';

@Component({
  selector: 'suc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(private i18nService: I18nService, @Inject(DOCUMENT) private document: Document) {}

  ngOnInit(): void {
    this.i18nService.init();

    // eslint-disable-next-line no-restricted-syntax
  }
}
